// extracted by mini-css-extract-plugin
export default {"title-container":"TitleWithIcon_title-container__SZwZp","title-container__icon":"TitleWithIcon_title-container__icon__08JHv"};